import { Flex, Input } from '@/components'
import {
  ColumnWrapper,
  Description,
  ScrollableContent,
  SectionTitle,
  StickyTitleContainer,
  Subtitle,
  TableContainer,
  Title,
} from '../../Cena.styles'
import { useCenaContext } from '../../Cena.context'
import { CenaTable, CenaTableColumn } from '../CenaTable/CenaTable.component'
import { UltraperformanceTable } from '../UltraperformanceTable/UltraperformanceTable.component'
import { RedeInputContainer } from './Rede.styles'

export function CenaRede() {
  const { rede, updateRede } = useCenaContext()

  const handleFieldChange = (field: string, value: string) => {
    updateRede({ [field]: value })
  }

  const handleNetworkApproachChange = (id: string, newValue: string) => {
    updateRede({
      networkApproachData: rede.networkApproachData.map((row) => (row.id === id ? { ...row, value: newValue } : row)),
    })
  }

  const handleNetworkVehicleChange = (id: string, newValue: string) => {
    updateRede({
      networkVehicleData: rede.networkVehicleData.map((row) => (row.id === id ? { ...row, value: newValue } : row)),
    })
  }

  const handleUltraPerformanceChange = (networkId: string, interactionId: string, newValue: string) => {
    updateRede({
      ultraPerformanceData: rede.ultraPerformanceData.map((network) =>
        network.id === networkId ?
          {
            ...network,
            interactions: network.interactions.map((interaction) =>
              interaction.id === interactionId ? { ...interaction, value: newValue } : interaction,
            ),
          }
        : network,
      ),
    })
  }

  const networkApproachColumns: CenaTableColumn[] = [
    {
      key: 'label',
      title: 'Abordagem',
      align: 'left',
    },
    {
      key: 'value',
      title: 'Pontos',
      align: 'center',
      width: 120,
    },
  ]

  const networkVehicleColumns: CenaTableColumn[] = [
    {
      key: 'label',
      title: 'Veículo',
      align: 'left',
    },
    {
      key: 'value',
      title: 'Pontos',
      align: 'center',
      width: 120,
    },
  ]

  return (
    <ColumnWrapper>
      <StickyTitleContainer>
        <Title>REDE</Title>
      </StickyTitleContainer>

      <ScrollableContent>
        <Flex $type="column" $align="stretch" $gap={24} style={{ paddingTop: '24px' }}>
          <Subtitle>Variáveis principais de exposição</Subtitle>
          <RedeInputContainer>
            <Input
              label="Peso das Interações"
              type="number"
              placeholder="Digite o peso"
              value={rede.interactionsWeight}
              onChange={(value) => handleFieldChange('interactionsWeight', value)}
            />
          </RedeInputContainer>

          <SectionTitle>Definição de pontos por Percentil para Curtidas</SectionTitle>
          <Flex $type="column" $align="stretch" $gap={16}>
            <RedeInputContainer>
              <Input
                label="Até p95 (menor estrito)"
                type="number"
                placeholder="Pontos"
                value={rede.likesP95}
                onChange={(value) => handleFieldChange('likesP95', value)}
              />
            </RedeInputContainer>
            <RedeInputContainer>
              <Input
                label="Entre p95 e p99"
                type="number"
                placeholder="Pontos"
                value={rede.likesP95P99}
                onChange={(value) => handleFieldChange('likesP95P99', value)}
              />
            </RedeInputContainer>
            <RedeInputContainer>
              <Input
                label="Maior ou igual a p99"
                type="number"
                placeholder="Pontos"
                value={rede.likesP99}
                onChange={(value) => handleFieldChange('likesP99', value)}
              />
            </RedeInputContainer>
          </Flex>

          <SectionTitle>Definição de pontos por Percentil para Comentários e Compartilhamentos</SectionTitle>
          <Flex $type="column" $align="stretch" $gap={16}>
            <RedeInputContainer>
              <Input
                label="Até p95 (menor estrito)"
                type="number"
                placeholder="Pontos"
                value={rede.commentsP95}
                onChange={(value) => handleFieldChange('commentsP95', value)}
              />
            </RedeInputContainer>
            <RedeInputContainer>
              <Input
                label="Entre p95 e p99"
                type="number"
                placeholder="Pontos"
                value={rede.commentsP95P99}
                onChange={(value) => handleFieldChange('commentsP95P99', value)}
              />
            </RedeInputContainer>
            <RedeInputContainer>
              <Input
                label="Maior ou igual a p99"
                type="number"
                placeholder="Pontos"
                value={rede.commentsP99}
                onChange={(value) => handleFieldChange('commentsP99', value)}
              />
            </RedeInputContainer>
          </Flex>

          <Subtitle>Peso Abordagem</Subtitle>
          <RedeInputContainer>
            <Input
              label="Multiplicador"
              type="number"
              placeholder="Multiplicador"
              value={rede.approachMultiplier}
              onChange={(value) => handleFieldChange('approachMultiplier', value)}
            />
          </RedeInputContainer>
          <TableContainer>
            <CenaTable
              columns={networkApproachColumns}
              data={rede.networkApproachData}
              onCellChange={(id, _, value) => handleNetworkApproachChange(id, value)}
            />
          </TableContainer>

          <Subtitle>Peso Canal</Subtitle>
          <RedeInputContainer>
            <Input
              label="Multiplicador"
              type="number"
              placeholder="Multiplicador"
              value={rede.channelMultiplier}
              onChange={(value) => handleFieldChange('channelMultiplier', value)}
            />
          </RedeInputContainer>
          <TableContainer>
            <CenaTable
              columns={networkVehicleColumns}
              data={rede.networkVehicleData}
              onCellChange={(id, _, value) => handleNetworkVehicleChange(id, value)}
            />
          </TableContainer>

          <Subtitle>Variáveis complementares de exposição</Subtitle>
          <RedeInputContainer>
            <Input
              label="Multiplicador"
              type="number"
              placeholder="Multiplicador"
              value={rede.complementaryMultiplier}
              onChange={(value) => handleFieldChange('complementaryMultiplier', value)}
            />
          </RedeInputContainer>
          <RedeInputContainer>
            <Input
              label="Mensagem-chave"
              type="number"
              placeholder="Pontos"
              value={rede.keyMessage}
              onChange={(value) => handleFieldChange('keyMessage', value)}
            />
          </RedeInputContainer>

          <SectionTitle>Filtro de Ultraperformance</SectionTitle>
          <Description>Excluir do cálculo postagens que não possuam pelo menos:</Description>

          <Flex $type="column" $align="stretch" $gap={16}>
            <SectionTitle>Para Facebook, Twitter e Instagram</SectionTitle>
            <Flex $type="row" $align="flex-start" $gap={16}>
              <RedeInputContainer>
                <Input
                  label="Curtidas"
                  type="number"
                  placeholder="Min. curtidas"
                  value={rede.filterLikesFB}
                  onChange={(value) => handleFieldChange('filterLikesFB', value)}
                />
              </RedeInputContainer>
              <RedeInputContainer>
                <Input
                  label="Comentários"
                  type="number"
                  placeholder="Min. comentários"
                  value={rede.filterCommentsFB}
                  onChange={(value) => handleFieldChange('filterCommentsFB', value)}
                />
              </RedeInputContainer>
              <RedeInputContainer>
                <Input
                  label="Compartilhamentos"
                  type="number"
                  placeholder="Min. compartilhamentos"
                  value={rede.filterSharesFB}
                  onChange={(value) => handleFieldChange('filterSharesFB', value)}
                />
              </RedeInputContainer>
            </Flex>

            <SectionTitle>Para YouTube</SectionTitle>
            <Flex $type="row" $align="flex-start" $gap={16}>
              <RedeInputContainer>
                <Input
                  label="Curtidas"
                  type="number"
                  placeholder="Min. curtidas"
                  value={rede.filterLikesYT}
                  onChange={(value) => handleFieldChange('filterLikesYT', value)}
                />
              </RedeInputContainer>
              <RedeInputContainer>
                <Input
                  label="Comentários"
                  type="number"
                  placeholder="Min. comentários"
                  value={rede.filterCommentsYT}
                  onChange={(value) => handleFieldChange('filterCommentsYT', value)}
                />
              </RedeInputContainer>
            </Flex>

            <SectionTitle>Para TikTok</SectionTitle>
            <Flex $type="row" $align="flex-start" $gap={16}>
              <RedeInputContainer>
                <Input
                  label="Curtidas"
                  type="number"
                  placeholder="Min. curtidas"
                  value={rede.filterLikesTT}
                  onChange={(value) => handleFieldChange('filterLikesTT', value)}
                />
              </RedeInputContainer>
              <RedeInputContainer>
                <Input
                  label="Comentários"
                  type="number"
                  placeholder="Min. comentários"
                  value={rede.filterCommentsTT}
                  onChange={(value) => handleFieldChange('filterCommentsTT', value)}
                />
              </RedeInputContainer>
              <RedeInputContainer>
                <Input
                  label="Compartilhamentos"
                  type="number"
                  placeholder="Min. compartilhamentos"
                  value={rede.filterSharesTT}
                  onChange={(value) => handleFieldChange('filterSharesTT', value)}
                />
              </RedeInputContainer>
            </Flex>
          </Flex>

          <RedeInputContainer>
            <Input
              label="Ponto extra dado a publicações cuja soma de interações totais seja superior a p95"
              type="number"
              placeholder="Pontos extras"
              value={rede.extraPointP95}
              onChange={(value) => handleFieldChange('extraPointP95', value)}
            />
          </RedeInputContainer>

          <SectionTitle>Multiplicadores de Ultraperformance</SectionTitle>
          <TableContainer>
            <UltraperformanceTable data={rede.ultraPerformanceData} onChange={handleUltraPerformanceChange} />
          </TableContainer>
        </Flex>
      </ScrollableContent>
    </ColumnWrapper>
  )
}
